import React, { useState } from 'react';
import logo from './../assets/images/logo.png';
import { Link, useNavigate } from 'react-router-dom';  //add by jinal
import Navbar from './../pages/Navbar';
import Footer from './../pages/Footer';
import './../App.css';

const ResetPassword = () => {
  const [formData, setFormData] = useState({
    newPassword: '',
    confirmPassword: '',
    token: new URLSearchParams(window.location.search).get('token') || '', // Get token from URL add by jinal
  });
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState(''); //add by jinal
  const [errorMessage, setErrorMessage] = useState('');  //add by jinal
  const navigate = useNavigate();  //add by jinal

  const validate = () => {
    const validationErrors = {};
    const { newPassword, confirmPassword } = formData;

    // Check if passwords are empty
    if (!newPassword) validationErrors.newPassword = 'New Password is required.';
    if (!confirmPassword) validationErrors.confirmPassword = 'Confirm Password is required.';

    // Check password length
    if (newPassword && newPassword.length < 6)
      validationErrors.newPassword = 'Password must be at least 6 characters long.';

    // Check if passwords match
    if (newPassword && confirmPassword && newPassword !== confirmPassword)
      validationErrors.confirmPassword = 'Passwords do not match.';

    return validationErrors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});
    //Below Add by jinal  http://localhost:5121/api/LoginRegistration/reset-password
    try {
      //const response = await fetch('http://localhost:5121/api/LoginRegistration/reset-password', {
      const response = await fetch('https://apiv2.chakran.in/api/LoginRegistration/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.message || 'Something went wrong');
      }

      setSuccessMessage('Password reset successfully. Redirecting to login...');
      setTimeout(() => navigate('/login'), 2000); // Redirect to login after 2 seconds
    } catch (error) {
      setErrorMessage(error.message || 'Something went wrong.');
    }
  };

  return (
    <>
      <Navbar />
      <div className="container d-flex align-items-center justify-content-center" style={{ minHeight: '80vh' }}>
        <div className="d-flex flex-column justify-content-between">
          <div className="row justify-content-center">
            <div className="col-lg-6 col-xl-6 col-md-10 ">
              <div className="card card-default mb-0">
                <div className="card-header pb-0">
                  <div className="app-brand w-100 d-flex justify-content-center border-bottom-0">
                    <Link className="w-auto pl-0" to="/signin">
                      <img src={logo} alt="Mono" />
                    </Link>
                  </div>
                </div>
                <div className="card-body px-4 pb-3 pt-0">
                  <h4 className="text-dark text-center mb-2">Reset Password</h4>
                  {successMessage && <div className="alert alert-success">{successMessage}</div>}
                  {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="form-group col-md-12 mb-2">
                        <input
                          type="password"
                          placeholder="New Password"
                          name="newPassword"
                          value={formData.newPassword}
                          onChange={handleChange}
                          className={`form-control ${errors.newPassword ? 'is-invalid' : ''}`}
                        />
                        {errors.newPassword && <div className="invalid-feedback">{errors.newPassword}</div>}
                      </div>
                      <div className="form-group col-md-12 mb-2">
                        <input
                          type="password"
                          placeholder="Confirm Password"
                          name="confirmPassword"
                          value={formData.confirmPassword}
                          onChange={handleChange}
                          className={`form-control ${errors.confirmPassword ? 'is-invalid' : ''}`}
                        />
                        {errors.confirmPassword && <div className="invalid-feedback">{errors.confirmPassword}</div>}
                      </div>

                      <div className="col-md-12">
                        <button type="submit" className="btn btn-primary btn-pill mt-2 mb-2">
                          Reset Password
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ResetPassword


// import React, { useState } from 'react';
// import logo from './../assets/images/logo.png';
// import { Link } from 'react-router-dom';
// import Navbar from './../pages/Navbar';
// import Footer from './../pages/Footer';
// import './../App.css';

// const ResetPassword = () => {
//   const [formData, setFormData] = useState({
//     newPassword: '',
//     confirmPassword: '',
//   });
//   const [errors, setErrors] = useState({});

//   const validate = () => {
//     const validationErrors = {};
//     const { newPassword, confirmPassword } = formData;

//     // Check if passwords are empty
//     if (!newPassword) validationErrors.newPassword = 'New Password is required.';
//     if (!confirmPassword) validationErrors.confirmPassword = 'Confirm Password is required.';

//     // Check password length
//     if (newPassword && newPassword.length < 8)
//       validationErrors.newPassword = 'Password must be at least 8 characters long.';

//     // Check if passwords match
//     if (newPassword && confirmPassword && newPassword !== confirmPassword)
//       validationErrors.confirmPassword = 'Passwords do not match.';

//     return validationErrors;
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const validationErrors = validate();
//     if (Object.keys(validationErrors).length > 0) {
//       setErrors(validationErrors);
//     } else {
//       setErrors({});
//       // Handle successful reset password logic here
//       console.log('Password successfully reset:', formData);
//     }
//   };

//   return (
//     <>
//       <Navbar />
//       <div className="container d-flex align-items-center justify-content-center" style={{ minHeight: '80vh' }}>
//         <div className="d-flex flex-column justify-content-between">
//           <div className="row justify-content-center">
//             <div className="col-lg-6 col-xl-6 col-md-10 ">
//               <div className="card card-default mb-0">
//                 <div className="card-header pb-0">
//                   <div className="app-brand w-100 d-flex justify-content-center border-bottom-0">
//                     <Link className="w-auto pl-0" to="/signin">
//                       <img src={logo} alt="Mono" />
//                     </Link>
//                   </div>
//                 </div>
//                 <div className="card-body px-4 pb-3 pt-0">
//                   <h4 className="text-dark text-center mb-2">Reset Password</h4>
//                   <form onSubmit={handleSubmit}>
//                     <div className="row">
//                       <div className="form-group col-md-12 mb-2">
//                         <input
//                           type="password"
//                           placeholder="New Password"
//                           name="newPassword"
//                           value={formData.newPassword}
//                           onChange={handleChange}
//                           className={`form-control ${errors.newPassword ? 'is-invalid' : ''}`}
//                         />
//                         {errors.newPassword && <div className="invalid-feedback">{errors.newPassword}</div>}
//                       </div>
//                       <div className="form-group col-md-12 mb-2">
//                         <input
//                           type="password"
//                           placeholder="Confirm Password"
//                           name="confirmPassword"
//                           value={formData.confirmPassword}
//                           onChange={handleChange}
//                           className={`form-control ${errors.confirmPassword ? 'is-invalid' : ''}`}
//                         />
//                         {errors.confirmPassword && <div className="invalid-feedback">{errors.confirmPassword}</div>}
//                       </div>

//                       <div className="col-md-12">
//                         <button type="submit" className="btn btn-primary btn-pill mt-2 mb-2">
//                           Reset Password
//                         </button>
//                       </div>
//                     </div>
//                     <input name="__RequestVerificationToken" type="hidden" value="" />
//                   </form>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <Footer />
//     </>
//   );
// };

// export default ResetPassword;
